import React from 'react';
import styles from './Dashboard.module.scss'
import DashboardBox from "components/miscellaneous/DashboardBox/DashboardBox";
import ClinicsMap from "components/Distributor/Dashboard/ClinicsMap/ClinicsMap";
import DistributorStats from "components/Distributor/Dashboard/Stats/Stats";
import DistributorMachineErrors from "components/Distributor/Dashboard/MachineErrors/MachineErrors";
import TopApplicators from 'components/Admin/Dashboard/TopApplicators/TopApplicators';
import PlatformsAnnualService from 'components/Distributor/Dashboard/PlatformsAnnualService/PlatformsAnnualService';
import { $t } from "helpers/translator";
import DateRangeSelector from 'components/miscellaneous/DateRangeSelector/DateRangeSelector';
import moment from 'moment';

const DistributorDashboard = () => {
    const [ dateRange, setDateRange ] = React.useState({
        startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    });

    return (
        <div className={ styles.container }>
            <div className={ styles.widget }>
                <div className={ `d-flex justify-content-between align-items-center ${styles.header}` }>

                    <h1 className={ styles.title }>Welcome back, <span>Distributor</span></h1>
                    <DateRangeSelector onChange={ (data) => {
                        // console.log(data)
                        setDateRange(data);
                    } } />
                </div>

            </div>
            <div className={ styles.widget }>
                <DistributorStats dateRange={ dateRange } />
            </div>

            <div className={ styles[ 'row' ] }>
                <div className={ `${styles[ 'component-block' ]} ${styles[ 'widget-treatment-areas' ]}` }>
                    <div className={ styles.widget }>
                        <DashboardBox info={ $t('global.chainDashboard.myClinicsInfo') }
                            header={ $t('global.chainDashboard.myClinics') }>
                            <ClinicsMap zoom={2} maxHeight={"300px"} />
                        </DashboardBox>
                    </div>
                </div>
                
                <div className={`${styles.row} ${styles.groupRow}`}>
                    <div className={ `${styles[ 'component-block' ]} ${styles[ 'widget-treatment-areas' ]}` }>
                        <div className={ styles.widget }>
                            <DashboardBox info={ "Machine Errors" }
                                header={ "Machine Errors" }>
                                    <DistributorMachineErrors dateRange={ dateRange } />
                            </DashboardBox>
                        </div>
                    </div>

                    <div className={`${styles['component-block']} ${styles['widget-applicators']}`}>
                        <DashboardBox header="Top Applicators" info="Top 5 most used applicators" link={{title: 'Applicators Page', to: "/equipment/applicators"}}>
                            <TopApplicators dateRange={dateRange} />
                        </DashboardBox>
                    </div>
                </div>
            </div>

            <div className={ styles.widget } style={{
                marginTop: 25
            }}>
                <DashboardBox header="Platforms That Require Annual Service" info="Showing all platforms that must have an annual service." >
                    <PlatformsAnnualService />
                </DashboardBox>
            </div>


        </div>
    )

}

export default DistributorDashboard;
